export default __webpack_public_path__ + "static/DIN-Regular-89242a89321beb3e838678b16b2e9ea6.woff";